import { useFlags } from '~/stores/use-flags/useFlags';
import { useSubscription } from '~/stores/use-subscription/useSubscription';

export const useIsEarningsInsightsEnabled = () => {
  const isEarningsInsightsEnabled = useFlags(state =>
    state.getFeatureFlagState('earnings_insights')
  );
  const isTerminal = useSubscription(
    state => state.isFromBO() || state.isTerminal()
  );

  return isEarningsInsightsEnabled && isTerminal;
};
